import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag, Pill, Sparkles, ArrowRight, Package2, ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const fmt = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
const fmtDay = (iso) => { try { return new Date(iso).toLocaleString([], { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

const STATUS_COLOR = {
  pending_payment: "#b5710d",
  paid: "#185FA5",
  packed: "#6938cb",
  shipped: "#3DAA82",
  delivered: "#16704b",
  cancelled: "#94a3b8",
  refunded: "#c03a2b",
};

export default function MyOrders() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    if (user === undefined) return;            // auth still loading
    if (!user) { nav("/patient?next=" + encodeURIComponent("/b2b/orders")); return; }
    api.get("/me/orders").then((r) => setOrders(r.data.orders || [])).catch(() => setOrders([])).finally(() => setLoading(false));
  }, [user, nav]);

  if (user === undefined) return <div className="ck-wrap"><p className="lead">Loading…</p></div>;
  if (!user) return null;
  return (
    <div className="ck-wrap" data-testid="my-orders">
      <button className="ck-back" onClick={() => nav(user.role === "doctor" ? "/doctor" : "/patient")}><ArrowLeft size={15} /> Back to portal</button>
      <h1 className="ck-h1">My orders</h1>
      <p className="ck-sub">All your pharmaceutical and nutraceutical orders.</p>

      {loading ? <p className="ck-muted">Loading…</p>
        : orders.length === 0 ? (
          <div className="ord-empty">
            <ShoppingBag size={40} />
            <h3>No orders yet</h3>
            <p>Shop our verified storefronts.</p>
            <div className="ord-empty-cta">
              <button className="pg-btn pg-btn-ghost" onClick={() => nav("/pharmaceuticals")}>Pharmacy</button>
              <button className="pg-btn pg-btn-ghost" onClick={() => nav("/nutraceuticals")}>Nutraceuticals</button>
            </div>
          </div>
        ) : (
          <div className="ord-list" data-testid="my-orders-list">
            {orders.map((o) => (
              <div key={o.id} className="ord-row" data-testid={`my-order-${o.id}`}>
                <div className="ord-row-top">
                  <b>#{o.id.slice(-8).toUpperCase()}</b>
                  <span className="ord-row-status" style={{ "--c": STATUS_COLOR[o.status] || "#475770" }}>
                    {(o.status || "").replace(/_/g, " ")}
                  </span>
                  <time>{fmtDay(o.created_at)}</time>
                </div>
                <div className="ord-row-items">
                  {(o.items || []).map((it, i) => {
                    const Ic = it.kind === "pharmaceutical" ? Pill : Sparkles;
                    return (
                      <span key={i} className="ord-item-chip">
                        <Ic size={12} /> {it.name} ×{it.qty}
                      </span>
                    );
                  })}
                </div>
                <div className="ord-row-foot">
                  <span><Package2 size={13} /> {(o.items || []).length} items</span>
                  <b>{fmt(o.total_amount)}</b>
                  <button className="pg-btn pg-btn-ghost" onClick={() => nav(`/b2b/order/${o.id}`)}>
                    View <ArrowRight size={13} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
